'use strict';

var React = require('react');

var SvgJobsMajor = function SvgJobsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 4.75v.75h-.5a3 3 0 0 0-3 3.018v5.482a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5.5a3 3 0 0 0-3-3h-.5v-.75a1.75 1.75 0 0 0-1.75-1.75h-3.5a1.75 1.75 0 0 0-1.75 1.75Zm1.75-.25a.25.25 0 0 0-.25.25v.75h4v-.75a.25.25 0 0 0-.25-.25h-3.5Zm5.75 2.5h-8a1.5 1.5 0 0 0-1.476 1.233c.044.045.096.095.154.151.247.232.617.546 1.104.861a7.707 7.707 0 0 0 4.218 1.255 7.707 7.707 0 0 0 4.217-1.255 7.783 7.783 0 0 0 1.26-1.012 1.5 1.5 0 0 0-1.477-1.233Zm-9.5 3.182a9.243 9.243 0 0 0 4.5 1.764v.054a1 1 0 1 0 2 0v-.054a9.241 9.241 0 0 0 4.5-1.764v3.818a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-3.818Z"
  }));
};
SvgJobsMajor.displayName = "JobsMajor";

exports.SvgJobsMajor = SvgJobsMajor;
